<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="40"
      height="40"
      rx="20"
      fill="#FFF7F2"
    />
    <path
      d="M17.93 20.99C18.03 20.99 20.35 21.09 21.73 20.75H21.74C23.33 20.36 25.54 19.24 26.11 15.58C26.11 15.58 27.38 11 21.08 11H15.67C15.18 11 14.76 11.36 14.68 11.84L12.38 26.4C12.33 26.7 12.57 26.98 12.87 26.98H16.3L17.14 21.66C17.2 21.28 17.53 20.99 17.93 20.99Z"
      fill="#040325"
    />
    <path
      d="M26.99 16.29C26.18 20.02 23.63 21.99 19.57 21.99H18.1L17.07 28.51C17.03 28.77 17.23 29 17.49 29H19.39C19.73 29 20.03 28.75 20.08 28.41C20.16 28.01 20.6 25.09 20.69 24.59C20.74 24.25 21.04 24 21.38 24H21.82C24.64 24 26.85 22.85 27.5 19.54C27.76 18.2 27.62 17.1 26.99 16.29Z"
      fill="#040325"
    />
  </svg>
</template>
